export default "__VITE_ASSET__AdWuBu_h__"